import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography } from '@material-ui/core';
import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useCallbackOne } from 'use-memo-one';
import { TableStateContext } from '../../../../contexts/tableState/TableStateContext';
import { ETablePopups } from '../../../../types/enums/ETablePopups';
import { ETables } from '../../../../types/enums/ETables';
import { IEditForm } from '../../../../types/interfaces/IEditForm';
import { endpoints } from '../../../../utils/endpoints';
import tPaths from '../../../../utils/tPaths';
import useApi from '../../../../utils/useApi';
import CustomSelect from '../../../CustomSelect/CustomSelect';
import InputForm from '../../../InputForm/InputForm';
import SwitchInput from '../../../SwitchInput/SwitchInput';
import useStyles from './AnalyticsPackagesHistory.styles';
import moment from 'moment';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { downloadFile } from '../../../../utils/downloadUtil';

enum EFields {
  FROM = 'from',
  TO = 'to',
}

interface IProps {
  tableName: string;
  isOpen: boolean;
  close: () => void;
}

const InitState: Record<EFields, string | boolean> = {
  [EFields.FROM]: moment().subtract(1, 'M').toISOString(),
  [EFields.TO]: moment().toISOString(),
};

const AnalyticsPackagesPopup: React.FC<IProps> = ({ isOpen, close }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { get } = useApi(null);
  const [state, setState] = useState<any>(InitState);

  const onDownload = useCallbackOne(() => {
    get({
      endpoint: endpoints.analyticsPackagesHistory(state),
      onSuccess: ({ data }) => downloadFile(data, { name: `Analytics-${state.from}-${state.to}`, extension: 'xlsx' }),
      options: { responseType: 'blob' },
    });
  }, [state]);

  return (
    <Dialog open={isOpen} fullWidth={true} onBackdropClick={close}>
      <DialogTitle>
        <Typography className={classes.title}>{t(tPaths.table.analyticsHistory)}</Typography>
      </DialogTitle>
      <Dialog open={isOpen} fullWidth={true} onBackdropClick={close}>
        <DialogTitle>
          <Typography className={classes.title}>{t(tPaths.tableGenerateCodes.title)}</Typography>
        </DialogTitle>

        <DialogContent>
          <Grid container spacing={1}>
            <Grid item xs={1}>
              <Box display={'flex'} alignItems={'center'} justifyContent={'center'} style={{ height: '100%' }}>
                <Typography variant="body2">{t(tPaths.table.fromTo(true))}</Typography>
              </Box>
            </Grid>
            <Grid item xs={10} className={classes.dateInput}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  format="yyyy-MM-dd"
                  value={state[EFields.FROM]}
                  onChange={(_e, date) =>
                    setState((v: any) => ({ ...v, [EFields.FROM]: moment(String(date)).toISOString() }))
                  }
                  disableToolbar
                  variant="inline"
                  margin="none"
                  id="date-picker-inline"
                  name={'From'}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                  inputProps={{
                    style: { width: 170 },
                    readOnly: true,
                  }}
                />
              </MuiPickersUtilsProvider>
            </Grid>
          </Grid>

          <Grid container spacing={1}>
            <Grid item xs={1}>
              <Box display={'flex'} alignItems={'center'} justifyContent={'center'} style={{ height: '100%' }}>
                <Typography variant="body2">{t(tPaths.table.fromTo(false))}</Typography>
              </Box>
            </Grid>
            <Grid item xs={10} className={classes.dateInput}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  format="yyyy-MM-dd"
                  value={state[EFields.TO]}
                  onChange={(_e, date) =>
                    setState((v: any) => ({ ...v, [EFields.TO]: moment(String(date)).toISOString() }))
                  }
                  disableToolbar
                  variant="inline"
                  margin="none"
                  id="date-picker-inline"
                  name={'From'}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                  inputProps={{
                    style: { width: 170 },
                    readOnly: true,
                  }}
                />
              </MuiPickersUtilsProvider>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions className={classes.actionsContainer}>
          <Button className={classes.button} onClick={close}>
            {t(tPaths.global.cancel)}
          </Button>
          <Button className={classes.button} color="secondary" onClick={() => (onDownload(), close())}>
            {t(tPaths.global.download)}
          </Button>
        </DialogActions>
      </Dialog>
    </Dialog>
  );
};

export default AnalyticsPackagesPopup;
